'use client';

import { ShowcaseIcon } from '../../collection-showcase/scenes/scene-primitives.jsx';
import { CompletionMark } from '../../collection-showcase/scenes/playback-controls.jsx';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import {
  ShowcaseCopyContext,
  translateShowcaseNode,
} from '../../collection-showcase/translation';
import { Rn, zn, Bn } from './quick-answer';
import { researchSources, hn, Sn, I, F, xn } from './research-facts';
export const deepTimeline = {
  rowsBy: (e) =>
    e < Rn
      ? 0
      : Math.min(researchSources.length, Math.floor((e - Rn) / zn) + 1),
  recommend: Bn,
  confirm: Bn + 600,
  ready: Bn + 1100,
  end: Bn + 1500,
};
export const Hn = [
  {
    label: 'Copy',
    icon: 'clipboard',
  },
  {
    label: 'Markdown',
    icon: 'doc',
  },
  {
    label: 'PDF',
    icon: 'doc',
  },
];
export function DeepResearch({ t: e, focus: t, onFocus: n }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let r = deepTimeline.rowsBy(e),
    i = e >= deepTimeline.ready;
  return (
    <div className={'enter flex flex-col gap-3'}>
      <div className={'flex items-center gap-2 px-1'}>
        <CompletionMark done={i} className={'size-4'} />
        <span className={'text-ink text-[14px] font-medium'}>
          {translateShowcaseNode(showcaseCopy, 'Linen overshirt pricing')}
        </span>
        <span className={'text-ink-4 num ml-auto text-[12px]'}>
          {translateShowcaseNode(
            showcaseCopy,
            i ? 'Report ready' : 'Researching'
          )}
        </span>
      </div>
      <div
        className={
          'rounded-[12px] bg-[var(--canvas)] p-3 shadow-[inset_0_0_0_1px_var(--line)] sm:p-4'
        }
      >
        <p className={'text-ink-3 m-0 text-[13px] leading-5'}>
          {translateShowcaseNode(showcaseCopy, 'Checked ')}
          {translateShowcaseNode(showcaseCopy, hn)}
          {translateShowcaseNode(showcaseCopy, '. ')}
          {translateShowcaseNode(showcaseCopy, Sn)}
        </p>
        <table
          className={
            'num mt-3 w-full border-collapse text-left text-[12.5px] leading-[18px]'
          }
        >
          <thead>
            <tr className={'text-ink-4 text-[11.5px]'}>
              <th className={'w-6 pb-1.5 font-medium'}>
                {translateShowcaseNode(showcaseCopy, '#')}
              </th>
              <th className={'pb-1.5 font-medium'}>
                {translateShowcaseNode(showcaseCopy, 'Product')}
              </th>
              <th className={'pb-1.5 text-right font-medium'}>
                {translateShowcaseNode(showcaseCopy, 'Price')}
              </th>
            </tr>
          </thead>
          <tbody>
            {translateShowcaseNode(
              showcaseCopy,
              researchSources.map((e, i) => {
                let a = t === e.n;
                return (
                  <tr
                    key={e.n}
                    data-cite={e.n}
                    className={'res-tr border-t border-[var(--line)]'}
                    data-on={i < r}
                    onMouseEnter={() => n(e.n)}
                    onMouseLeave={() => n(null)}
                  >
                    <td className={'py-1.5 align-top'}>
                      <span
                        className={`grid size-[18px] place-items-center rounded-[5px] text-[10.5px] font-medium transition-[background-color,color] duration-150 ${a ? 'bg-[var(--primary)] text-[var(--primary-foreground)]' : 'text-ink-3 bg-[var(--tint-2)]'}`}
                      >
                        {translateShowcaseNode(showcaseCopy, e.n)}
                      </span>
                    </td>
                    <td className={'py-1.5 pr-2'}>
                      <span className={'text-ink block'}>
                        {translateShowcaseNode(showcaseCopy, e.brand)}
                      </span>
                      <span
                        className={
                          'text-ink-4 block truncate max-sm:max-w-[150px]'
                        }
                      >
                        {translateShowcaseNode(showcaseCopy, e.product)}
                      </span>
                    </td>
                    <td
                      className={
                        'text-ink py-1.5 text-right align-top whitespace-nowrap'
                      }
                    >
                      {translateShowcaseNode(
                        showcaseCopy,
                        e.sale === null ? (
                          I(e.price)
                        ) : (
                          <React.Fragment>
                            {translateShowcaseNode(showcaseCopy, I(e.sale))}
                            {translateShowcaseNode(showcaseCopy, ' ')}
                            <span className={'text-ink-4 line-through'}>
                              {translateShowcaseNode(showcaseCopy, I(e.price))}
                            </span>
                          </React.Fragment>
                        )
                      )}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
      <p
        className={'res-note text-ink m-0 px-1 text-[14px] leading-[22px]'}
        data-on={e >= deepTimeline.recommend}
      >
        <span className={'font-medium'}>
          {translateShowcaseNode(showcaseCopy, 'Target ')}
          {translateShowcaseNode(showcaseCopy, I(F.low))}
          {translateShowcaseNode(showcaseCopy, '\u2013')}
          {translateShowcaseNode(showcaseCopy, F.high)}
          {translateShowcaseNode(showcaseCopy, ', with ')}
          {translateShowcaseNode(showcaseCopy, I(F.start))}
          {translateShowcaseNode(showcaseCopy, ' ')}
          {translateShowcaseNode(showcaseCopy, 'as the starting point.')}
        </span>
      </p>
      <div
        className={
          'res-note flex items-start gap-2.5 rounded-[10px] px-3 py-2.5 text-[13px] leading-5 shadow-[inset_0_0_0_1px_var(--border)]'
        }
        data-on={e >= deepTimeline.confirm}
      >
        <ShowcaseIcon
          name={'search'}
          className={'text-ink-3 mt-0.5 size-4 shrink-0'}
        />
        <span>
          <span className={'text-ink font-medium'}>
            {translateShowcaseNode(showcaseCopy, 'Couldn\u2019t confirm. ')}
          </span>
          <span className={'text-ink-3'}>
            {translateShowcaseNode(showcaseCopy, xn)}
            {translateShowcaseNode(showcaseCopy, ' Size availability varies.')}
          </span>
        </span>
      </div>
      <div
        className={'res-note pointer-events-none flex flex-wrap gap-1.5'}
        data-on={i}
        aria-hidden={!0}
      >
        {translateShowcaseNode(
          showcaseCopy,
          Hn.map((e) => (
            <span key={e.label} className={'btn btn-soft btn-sm'}>
              <ShowcaseIcon name={e.icon} className={'size-3.5'} />
              {translateShowcaseNode(showcaseCopy, e.label)}
            </span>
          ))
        )}
      </div>
    </div>
  );
}
export function CitationConnectors({
  root: e,
  from: t,
  to: n,
  version: r,
  focus: i,
}) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let [a, o] = React.useState([]),
    [s, c] = React.useState({
      w: 0,
      h: 0,
    });
  return (
    React.useLayoutEffect(() => {
      let r = e.current,
        i = t.current,
        a = n.current;
      if (!r || !i || !a) return;
      let s = () => {
        let e = r.getBoundingClientRect(),
          t = i.getBoundingClientRect();
        if (
          (c({
            w: e.width,
            h: e.height,
          }),
          t.right >= a.getBoundingClientRect().left)
        ) {
          o([]);
          return;
        }
        let n = new Map(),
          s = [];
        (i.querySelectorAll('[data-cite]').forEach((r) => {
          let i = Number(r.dataset.cite),
            o = a.querySelector(`[data-src="${i}"]`);
          if (!o || r.closest('[data-on="false"]')) return;
          let c = r.getBoundingClientRect(),
            l = o.getBoundingClientRect(),
            u = t.right - e.left + 6,
            d = c.top + c.height / 2 - e.top,
            f = l.left - e.left - 4,
            p = l.top + l.height / 2 - e.top,
            m = (f - u) * 0.55,
            h = (n.get(String(i)) ?? 0) + 1;
          (n.set(String(i), h),
            s.push({
              n: i,
              key: `${i}-${h}`,
              x1: u,
              y1: d,
              d: `M${u} ${d}C${u + m} ${d} ${f - m} ${p} ${f} ${p}`,
            }));
        }),
          o(s));
      };
      s();
      let l = new ResizeObserver(s);
      l.observe(r);
      l.observe(i);
      return () => l.disconnect();
    }, [e, t, n, r]),
    a.length === 0 ? null : (
      <svg
        aria-hidden={!0}
        className={
          'pointer-events-none absolute inset-0 overflow-visible max-lg:hidden'
        }
        width={s.w}
        height={s.h}
        fill={'none'}
      >
        {translateShowcaseNode(
          showcaseCopy,
          a.map((e) => {
            let t = i === e.n;
            return (
              <g key={e.key} className={'res-wire'} data-on={t}>
                <path d={e.d} pathLength={1} className={'res-wire-path'} />
                <circle cx={e.x1} cy={e.y1} r={2} className={'res-wire-dot'} />
              </g>
            );
          })
        )}
      </svg>
    )
  );
}
export const Gn = [
  {
    value: 'quick',
    label: 'Quick answer',
  },
  {
    value: 'deep',
    label: 'Deep research',
  },
];
export const Kn = {
  quick: 'Answers in seconds, every number linked to its source.',
  deep: 'A full report when the decision matters.',
};
